import React, { useEffect } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import withoutAuth from '../../hoc/withoutAuth';
import { getUser } from '../../services/auth.service';
import { hasAnyRoles } from '../../lib/role';
import { setUser } from '../../store/auth/actions';
import { LocalStorage } from '../../customer-call-sdk';
import StorageContants from '../../config/storage.constants';
import { useToast } from '../../context/ToastContext';

const OAuth2RedirectHandler: React.FC = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const toast = useToast();

    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const error = queryParams.get('error');

    const showErrorAndRedirect = (message: string) => {
        toast.error(message);
        navigate('/login');
    };

    const fetchUser = async () => {
        const { data, error: responseError } = await getUser();
        if (data) {
            if (hasAnyRoles(data.user.roles, ['ROLE_USER', 'ROLE_SL_GUEST'])) {
                dispatch(setUser(data.user));
            } else {
                LocalStorage.remove(StorageContants.ACCESS_TOKEN);
                showErrorAndRedirect('User not allowed');
            }
        }
        if (responseError) {
            LocalStorage.remove(StorageContants.ACCESS_TOKEN);
            showErrorAndRedirect(responseError);
        }
    };

    useEffect(() => {
        if (token) {
            LocalStorage.set(StorageContants.ACCESS_TOKEN, token);
            fetchUser();
        }

        if (error) {
            showErrorAndRedirect(error);
        }
    }, []);

    if (!token) {
        return <Navigate to="/" replace />;
    }
    return <div>Loading....</div>;
};

export default withoutAuth(OAuth2RedirectHandler);
